const liveChat = Array.from(document.querySelectorAll('.live-chat'));

liveChat.forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    window.open(el.href, 'wochat','width=484,height=361'); 
  });
});